

function TitleRules() {
    return (
        <div className="fixed top-0 left-0 right-0 bg-slate-50 flex flex-row-reverse items-center justify-center w-full py-10 shadow">
            <img src="/image/Logo.png" className="w-10 ml-10" />
            <h2 className="font-bold text-lg">قوانین و شرایط استفاده از پیام رسان بوستان</h2>
        </div>
    );
}

export default TitleRules;